/**
 * @module utils/upload
 */

import axios from 'axios'
import store from '../store'
import { setUploadsAction, finishUploadsIfAllDone } from '../actions/uploads'

export function clearUploads () {
  if (window.uploads !== undefined && window.uploads !== null) {
    window.uploads.splice(0, window.uploads.length)
  }
  updateRedux()
}

/**
 * @description gets details about files currently being uploaded
 * @return {object} Returns object
 */
export function getUploads () {
  if (window.uploads === undefined || window.uploads === null) {
    window.uploads = []
  }
  return window.uploads
}

export function queueUpload (url, file, data) {
  return dispatch => {
    let key = Math.floor(Math.random() * 10000000)
    var CancelToken = axios.CancelToken
    var source = CancelToken.source()

    const config = {
      cancelToken: source.token,
      onUploadProgress: evt => {
        updateUploads(key, file, evt, source.cancel)
      }
    }
    return axios.post(url, data, config).then((res) => {
      dispatch(finishUploadsIfAllDone())
      return res
    }).catch((thrown) => {
      if (axios.isCancel(thrown)) {
        console.log('cancel')
        clearUploads()
      } else {
        console.log('other error')
        clearUploads()
      }
    })
  }
}

export function cancelUploads () {
  let uploads = getUploads()
  if (uploads.length > 0) {
    for (let i = 0; i < uploads.length; i++) {
      if (uploads[i].cancel !== null) {
        uploads[i].cancel()
      }
    }
    clearUploads()
  }
  updateRedux()
}

export function updateUploads (key, file, evt, cancel) {
  let uploads = getUploads()
  let total = evt.lengthComputable ? evt.total : evt.target.getResponseHeader('content-length') || evt.target.getResponseHeader('x-decompressed-content-length')
  let fileInfo = {
    name: '',
    size: total,
    type: '',
    loaded: evt.loaded,
    lengthComputable: evt.lengthComputable
  }
  if (file !== null && file.name !== undefined && file.type !== undefined) {
    fileInfo.name = file.name
    fileInfo.type = file.type
  }
  let entry = {
    key: key,
    cancel: cancel,
    file: fileInfo
  }

  let index = uploads.findIndex((item) => { return item.key === entry.key && item.file.name === entry.file.name })
  if (index >= 0) {
    uploads[index] = entry
  } else {
    uploads.push(entry)
  }

  updateRedux()

  // Clear completed
  // for (let i = uploads.length - 1; i >= 0; i--) {
  //   let item = uploads[i]
  //   if (item.file.loaded >= item.file.size) {
  //     uploads.splice(i, 1)
  //   }
  // }
  // updateRedux()
}

function updateRedux () {
  store.dispatch(setUploadsAction(getUploads()))
}



// WEBPACK FOOTER //
// ./src/app/utils/upload.js